// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarMinimal_navbar__ISQgo","navbarMain":"NavbarMinimal_navbarMain__rak8Z","link":"NavbarMinimal_link__usU9F"};